export enum CHECKOUT_STUDENT_FLOW {
    EXISTING_STUDENT_SELECTION_FLOW = "existing_student_flow",
    ADD_STUDENT_FLOW = "add_student_flow"
}
